import { Table } from 'react-bootstrap'
import ParamRow from './ParamRow'

const ParamGroup = ({ group, api, onSaved }) => {
    return (
        <div className='mb-4'>
            <h5 className='fw-semibold border-bottom pb-2 mb-0'>{group.label}</h5>
            <Table hover className='mb-0' responsive>
                <tbody>
                    {group.params.map(param => (
                        <ParamRow
                            key={param.paramId}
                            dbRow={param}
                            api={api}
                            onSaved={onSaved}
                        />
                    ))}
                </tbody>
            </Table>
        </div>
    )
}

export default ParamGroup
